import styled from 'styled-components'

import Box from '../../../../layout/Box/Box'

export const ColumnConfigurationScrollingArea = styled(Box)`
  max-height: 370px;
  overflow-y: auto;
  scrollbar-width: thin;
`
